const hostname = window && window.location && window.location.hostname;
const protocol = window && window.location && window.location.protocol;

export const serviceUrl = `${protocol}//${hostname}`;

const proxiedServiceUrl =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : serviceUrl;

const paths = {
  dictionary: (locale) => `${proxiedServiceUrl}/dictionary/${locale}`,
  login: () => `${proxiedServiceUrl}/bulkuploadApi/api/auth/login`,
  fileValidation: () => `${proxiedServiceUrl}/bulkuploadApi/api/v2/validateFile`,
  getJobStatus: (userId, pageNumber, sortType, sortId, rpp = 10, searchKeyword = '') =>
    `${proxiedServiceUrl}/bulkuploadApi/api/v2/bulkJob?userId=${userId}&pageNo=${pageNumber}&rpp=${rpp}&sortType=${sortType}&coulmnToBeSorted=${sortId}&searchKeyword=${searchKeyword}`,
  getJobDetail: (id, pageNumber, sortType, sortId, rpp = 10, status = [], searchKeyword = '') =>
    `${proxiedServiceUrl}/bulkuploadApi/api/v2/nifiJobs/${id}?status=${status}&pageNo=${pageNumber}&rpp=${rpp}&sortType=${sortType}&coulmnToBeSorted=${sortId}&searchKeyword=${searchKeyword}`,
  pubMedIdSearch: (id) => `${proxiedServiceUrl}/bulkuploadApi/api/v2/lookup/${id}`,
  getSignedUrl:(objectKey)=>`${proxiedServiceUrl}/bulkuploadApi/api/v2/signedurl?objectKey=${objectKey}`,
  getAssetTypes:()=> `${proxiedServiceUrl}/bulkuploadApi/api/v2/model-metadata`,
  getSimpleSearch: (keyword, pageNumber,pageSize )=> `${proxiedServiceUrl}/bulkuploadApi/api/v2/asset-metadata-search?q=${keyword}&page_size=${pageSize}&page_number=${pageNumber}`,
  getAdvancedSearch: (pageNumber,pageSize )=> `${proxiedServiceUrl}/bulkuploadApi/api/v2/asset-metadata-advanced-search?page_size=${pageSize}&page_number=${pageNumber}`,
  getDropDownValues: (id) => `${proxiedServiceUrl}/bulkuploadApi/api/v2/lookup_domain?fetch_id=${id}`,
  validateSku: () =>
    `${proxiedServiceUrl}/bulkuploadApi/api/v2/validateGID`,
  uploadAsset: () =>`${proxiedServiceUrl}/bulkuploadApi/api/v2/asset/`,
  getAssetDetails: (id) => `${proxiedServiceUrl}/bulkuploadApi/api/v2/asset/${id}`,
  publishOrUnpublishAsset: (id,action,userId) =>
    `${proxiedServiceUrl}/bulkuploadApi/api/v2/asset/action/${id}?action=${action}&userId=${userId}`,
  bulkJobId: ()=>`${proxiedServiceUrl}/bulkuploadApi/api/v2/bulkJob`,
  auditAssets: (id,pageNumber,pageSize) => `${proxiedServiceUrl}/bulkuploadApi/api/v2/asset_audit/${id}?page=${pageNumber}&size=${pageSize}`,
  nifiReport: (apps, source, startDate, endDate) => {
    let url = `${proxiedServiceUrl}/bulkuploadApi/api/v2/nifi-report?apps=${apps}`;
    if (source) {
      url += `&source=${source}`;
    }
    if (startDate) {
      url += `&start_date=${startDate}`;
    }
    if (endDate) {
      url += `&end_date=${endDate}`;
    }
    return url;
  },
  nifiDailyTrends: (apps, source, startDate, endDate) => {
    let url = `${proxiedServiceUrl}/bulkuploadApi/api/v2/nifi-report/daily-trends`;
    const params = [];
    if (apps) {
      params.push(`apps=${apps}`);
    }
    if (source) {
      params.push(`source=${source}`);
    }
    if (startDate) {
      params.push(`start_date=${startDate}`);
    }
    if (endDate) {
      params.push(`end_date=${endDate}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return url;
  },
  assetAuditDetails: (assetId,auditId) => `${proxiedServiceUrl}/bulkuploadApi/api/v2/asset_audit_by_id/?asset_id=${assetId}&audit_id=${auditId}`
};

export default paths;
